import type { LinkProps } from "@remix-run/react";
import { useLocation } from "@remix-run/react";
import { CKLink } from "@commercekit/ui";
import { useAnchor } from "@commercekit/react";
import { useLocalePath } from "@commercekit/remix/lib/hooks/useLocale";

const prefetchFn: (
  to: LinkProps["to"],
  localePath: (v: string) => string
) => LinkProps["prefetch"] = (to, localePath) => {
  let pathName;
  if (typeof to === "string") {
    pathName = to;
  } else {
    pathName = to.pathname || "";
  }
  if (pathName.startsWith(localePath("/cart/"))) {
    return "none";
  }
  if (pathName.startsWith(localePath("/customer"))) {
    return "none";
  }
  return "intent";
};
const WvLink = (props: LinkProps) => {
  const pathname = useLocation().pathname;
  const { isAnchor, anchorTo } = useAnchor(props.to, pathname);
  const localePath = useLocalePath();
  return (
    <CKLink
      onClick={(e) => {
        if (isAnchor) {
          anchorTo();
          e.preventDefault();
        }
      }}
      prefetchFn={(to) => prefetchFn(to, localePath)}
      {...props}
    ></CKLink>
  );
};

export default WvLink;
